import { RecoveryApproval } from "@/features/recovery/recovery-approval";

export default function RecoveryApprovalPage() {
  return <RecoveryApproval />;
}
